(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/views/coupon/reduction/reduction.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/views/coupon/reduction/reduction.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen = svs.matchen || {};
  svs.matchen.views = svs.matchen.views || {};

  svs.matchen.views.Reduction = Marionette.View.extend({
    events: {
      'click .js-reduction': 'onCheck'
    },

    className: 'form-toggle',

    template: function(data) {
      return svs.matchen.templates.reduction(data);
    },

    templateContext: function() {
      return {
        isMaximumNumberOfReductionsSelected: this.model.collection.isMaximumNumberOfReductionsSelected()
      };
    },

    initialize: function() {
      this.listenTo(this.model.collection, 'change:selected', this.render);
    },

    onCheck: function() {
      this.model.set('selected', !this.model.get('selected'));
    }
  });
})(Backbone, _, svs);


 })(window);